import * as yup from 'yup';

export const EARLY_CHECK_IN_VALUES_VALIDATION_SCHEMA = yup.object().shape({
  allowEarlyCheckIn: yup.boolean(),
  earlyCheckInType: yup.string(),
  timeConstrainedInMinutes: yup.number(),
});
